
import { Post } from '@/mocks';
import { defineComponent, onMounted, ref, watchEffect, watch } from 'vue';
import { parse } from 'marked';
import highlight from 'highlight.js';
import debounce from 'lodash/debounce';

export default defineComponent({
  name: 'PostWriter',
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
  },

  emits: {
    save: (post: Post) => {
      return true;
    },
  },

  setup(props, ctx) {
    const title = ref(props.post.title);
    const content = ref('## Title\nEnter your post content...');
    const contentEditable = ref<HTMLDivElement | null>(null);
    const html = ref('');

    const parseHtml = (str: string) => {
      html.value = parse(str, {
        gfm: true,
        breaks: true,
        highlight: (code: string) => {
          return highlight.highlightAuto(code).value;
        },
      });
    };

    // watchEffect(() => {
    //   html.value = parse(content.value, {
    //     gfm: true,
    //     breaks: true,
    //     highlight: (code: string) => {
    //       return highlight.highlightAuto(code).value;
    //     },
    //   });
    // });

    watch(
      content,
      debounce((newVal) => {
        parseHtml(newVal);
      }, 250),
      {
        immediate: true,
      }
    );

    const handleInput = () => {
      if (!contentEditable.value) {
        throw Error('This should never happen');
      }
      content.value = contentEditable.value?.innerText || '';
    };

    onMounted(() => {
      if (!contentEditable.value) {
        throw Error('This should never happen');
      }
      contentEditable.value.innerText = content.value;
    });

    const save = () => {
      const newPost: Post = {
        ...props.post,
        title: title.value,
        html: html.value,
        markdown: content.value,
      };
      ctx.emit('save', newPost);
    };

    return {
      save,
      html,
      title,
      content,
      contentEditable,
      handleInput,
    };
  },
});
